import { getCountryAlpha2 } from "@nemuru-eng/js-api-client";

export const addressMapper = {
  toDto: (address) => {
    if (!address) {
      throw new Error("Address is required in addressMapper");
    }
    return {
      geoLocateProviderAddress: {
        postalCode: address.postalCode,
        countryShortName: getCountryAlpha2(address.country),
        streetNumber: address.streetNumber,
        streetName: address.streetName,
        city: address.city,
        countryLongName: address.countryLongName,
        ...(address.region ? { regionLongName: address.region } : {}),
        ...(address.regionShortName
          ? { regionShortName: address.regionShortName }
          : {}),
        ...(address.province ? { provinceLongName: address.province } : {}),
        ...(address.provinceShortName
          ? { provinceShortName: address.provinceShortName }
          : {}),
        ...(address.latitude
          ? {
              geoLocateCoordinates: {
                latitude: address.latitude,
                longitude: address.longitude,
              },
            }
          : {}),
      },
      formattedAddress: `${address.streetName}${
        address.streetNumber ? ` ${address.streetNumber}` : ""
      }, ${address.postalCode} ${address.city}, ${address.countryLongName}`,
      floorNumber: address.floorNumber,
      doorNumber: address.doorNumber,
      building: address.building,
    };
  },
};
